<template>
    <v-container fluid>
        <v-row>
            <v-col sm="9" cols="12" class="d-flex">
                <div class="mr-2" v-if="$vuetify.display.smAndUp">
                    <v-btn-back @click.stop="back()" v-if="mode != 'GeneralLedger'"> </v-btn-back>
                </div>
                <div>
                    <h1 v-if="!$vuetify.display.mobile">{{ clientTitle }}</h1>
                    <h2 v-else>{{ clientTitle }}</h2>
                </div>
                <!-- <div>
                    <v-btn rounded="circle" size="small" @click.stop="help()" class="ml-3 elevation-0">
                        <v-icon>$fa-question</v-icon>
                    </v-btn>
                </div> -->
            </v-col>
        </v-row>

        <v-row>
            <v-col v-if="$vuetify.display.mobile" cols="12">
                <div
                    v-for="al of groupedAccountingLines"
                    :key="al.id"
                    class="default_card_wm pa-2 mb-3"
                >
                    <div v-for="(ai, aiIndex) in al.items" :key="al.id + '.' + ai.id">
                        <!-- <v-row>
                            <v-col class="d-flex align-center">
                                <v-icon left> {{ ai.iconType }}</v-icon>
                                {{ formatDate(ai.date) }}
                            </v-col>
                            <v-col class="d-flex justify-end">
                                <v-chip
                                    label outlined
                                     size="small"
                                    color="primary"
                                    v-if="aiIndex===0 && groupStatusWithoutAA(al)"
                                >
                                    {{groupStatusWithoutAA(al)}}
                                </v-chip>
                            </v-col>
                        </v-row>
                        <div class="mt-3">
                            <v-chip outlined label size="small" color="grey" class="mr-2" v-if="(ai.bt && ai.bt.accountingItemImport)||(ai.doc && ai.doc.accountingItemImport)">Importé</v-chip>
                            {{ ai.name }}
                        </div>
                        <div v-if="ai.bt" class="text--secondary">
                            <span v-if="ai.suppliers">Fournisseur: {{ ai.suppliers }}</span>
                            <span v-if="ai.customers">Client: {{ ai.customers }}</span>
                            <span v-if="ai.user">Collaborateur : {{ ai.user }}</span>
                            <span v-if="ai.bankAccount">Compte bancaire : {{ ai.bankAccount }}</span>
                        </div>
                        <div v-if="ai.doc">
                            <span v-if="ai.doc.type==='WITHOUT_INVOICE'">Sans justificatif</span>
                            <span v-else-if="ai.doc.type==='SALES_INVOICE_AUTO'">Encaissemment</span>
                        </div>
                        <v-divider class="mt-3 mb-2"></v-divider>
                        <v-row>
                            <v-col cols="6" class="d-flex justify-end pr-4">
                                {{ ai.debit ? newCommonFormatCurrency(ai.debit, undefined) : "-" }}
                            </v-col>
                            <v-col cols="6" class="d-flex justify-end pr-4">
                                {{ ai.credit ? newCommonFormatCurrency(ai.credit, undefined) : "-" }}
                            </v-col>
                        </v-row> -->
                        <v-row>
                            <v-col>
                                <v-icon size="small" location="start"> {{ ai.iconType }}</v-icon>
                                <v-chip
                                    label
                                    color="grey"
                                    class="mr-2"
                                    v-if="
                                        (ai.bt && ai.bt.accountingItemImport) ||
                                        (ai.doc && ai.doc.accountingItemImport)
                                    "
                                    size="small"
                                    variant="outlined"
                                    >Importé</v-chip
                                >
                                {{ ai.name }}
                                <div v-if="ai.bt" class="text--secondary mt-1">
                                    <span v-if="ai.suppliers">Fournisseur: {{ ai.suppliers }}</span>
                                    <span v-if="ai.customers">Client: {{ ai.customers }}</span>
                                    <span v-if="ai.user">Collaborateur : {{ ai.user }}</span>
                                    <span v-if="ai.bankAccount"
                                        >Compte bancaire : {{ ai.bankAccount }}</span
                                    >
                                </div>
                                <div v-if="ai.doc">
                                    <span v-if="ai.doc.type === 'WITHOUT_INVOICE'"
                                        >Sans justificatif</span
                                    >
                                    <span v-else-if="ai.doc.type === 'SALES_INVOICE_AUTO'"
                                        >Encaissemment</span
                                    >
                                </div>
                            </v-col>
                        </v-row>
                        <v-divider class="mt-3 mb-2" />
                        <v-row class="d-flex">
                            <v-col class="d-flex align-center">
                                {{ formatDate(ai.date) }}
                            </v-col>
                            <v-col
                                class="d-flex align-center flex-shrink-1 flex-grow-0"
                                v-if="aiIndex === 0 && groupStatusWithoutAA(al)"
                            >
                                <v-chip label size="small" variant="outlined">
                                    {{ groupStatusWithoutAA(al) }}
                                </v-chip>
                            </v-col>
                            <v-col
                                class="d-flex align-center justify-end flex-grow-1 flex-shrink-0"
                            >
                                {{
                                    ai.debit
                                        ? `Debit: ${newCommonFormatCurrency(ai.debit, undefined)}`
                                        : ""
                                }}
                                {{
                                    ai.credit
                                        ? `Credit: ${newCommonFormatCurrency(ai.credit, undefined)}`
                                        : ""
                                }}
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-col>
            <v-col v-else>
                <v-data-table
                    :headers="groupItemsHeaders2"
                    :items="groupedAccountingLines"
                    hide-default-footer
                    :items-per-page="-1"
                    class="table"
                    fixed-header
                    max-height="60vh"
                    :loading="loading"
                    style="width: 100%"
                    xs12
                >
                    <template v-slot:item="{ item, index }">
                        <!-- <td v-for="(header) in reconciliationItems">{{ item[header.value] }}</td> -->
                        <tr
                            :style="
                                alIndex === 0
                                    ? 'cursor: pointer; border-top;font-weight: bold;'
                                    : 'cursor: pointer'
                            "
                            v-for="(accountingItem, alIndex) in item.items"
                            :key="index + '-' + alIndex"
                            @click.stop="addRemoveReconciliationExpend(accountingItem)"
                        >
                            <td class="text-center" :style="getCellStyle(alIndex, false)">
                                <v-icon :small="true" class="mr-2">{{
                                    accountingItem.iconType
                                }}</v-icon>
                            </td>
                            <!-- <td class="text-xs-left">{{ accountingItem.type }}</td> -->
                            <td class="text-left" :style="getCellStyle(alIndex, false)">
                                <div>
                                    <v-chip
                                        label
                                        color="grey"
                                        class="mr-2"
                                        v-if="
                                            (accountingItem.bt &&
                                                accountingItem.bt.accountingItemImport) ||
                                            (accountingItem.doc &&
                                                accountingItem.doc.accountingItemImport)
                                        "
                                        size="small"
                                        variant="outlined"
                                        >Importé</v-chip
                                    >{{ accountingItem.name }}
                                </div>
                                <div v-if="accountingItem.bt">
                                    <span v-if="accountingItem.suppliers"
                                        >Fournisseur: {{ accountingItem.suppliers }}</span
                                    >
                                    <span v-if="accountingItem.customers"
                                        >Client: {{ accountingItem.customers }}</span
                                    >
                                    <span v-if="accountingItem.user"
                                        >Collaborateur : {{ accountingItem.user }}</span
                                    >
                                    <span v-if="accountingItem.bankAccount"
                                        >Compte bancaire : {{ accountingItem.bankAccount }}</span
                                    >
                                </div>
                                <div v-if="accountingItem.doc">
                                    <!-- <v-chip  size=“x-small” label :ripple="false" v-if="accountingItem.doc.status.startsWith('ANALYSED')">
                                        <span :style="'color:orange;'">A valider</span>
                                    </v-chip> -->
                                    <span v-if="accountingItem.doc.type === 'WITHOUT_INVOICE'"
                                        >Sans justificatif</span
                                    >
                                    <span
                                        v-else-if="accountingItem.doc.type === 'SALES_INVOICE_AUTO'"
                                        >Encaissemment</span
                                    >
                                </div>
                            </td>
                            <td class="text-center" :style="getCellStyle(alIndex, false)">
                                {{ accountingItem.date }}
                            </td>
                            <td class="text-right" :style="getCellStyle(alIndex, false)">
                                <span v-if="isMainItem(item, accountingItem)">{{
                                    accountingItem.debit
                                        ? newCommonFormatCurrency(accountingItem.debit, undefined)
                                        : "-"
                                }}</span>
                            </td>
                            <td class="text-right" :style="getCellStyle(alIndex, false)">
                                <span v-if="isMainItem(item, accountingItem)">{{
                                    accountingItem.credit
                                        ? newCommonFormatCurrency(accountingItem.credit, undefined)
                                        : "-"
                                }}</span>
                            </td>
                            <td
                                class="text-center"
                                :style="getCellStyle(alIndex, false)"
                                v-if="isAccountingUser"
                            >
                                <span
                                    :style="getIfNecessaryAccountableAccountColor(item, alIndex)"
                                    >{{ getIfNecessaryAccountableAccount(item, alIndex) }}</span
                                >
                            </td>
                            <td class="text-center" :style="getCellStyle(alIndex, false)">
                                <v-chip
                                    class="ma-2 font-weight-regular"
                                    label
                                    v-if="alIndex === 0 && groupStatusWithoutAA(item)"
                                    size="small"
                                    variant="outlined"
                                    >{{ groupStatusWithoutAA(item) }}</v-chip
                                >
                            </td>
                            <td
                                class="text-center"
                                :style="getCellStyle(alIndex, true)"
                                v-if="isAccountingUser"
                            >
                                <v-list rounded class="ma-2" density="compact">
                                    <v-list-item
                                        v-if="needsAction(item)"
                                        @click.stop="activateActionMenu($event, item)"
                                    >
                                        <v-list-item-title>Plus d'actions</v-list-item-title>

                                        <template #append>
                                            <v-icon size="x-small">$dots_vertical</v-icon>
                                        </template>
                                    </v-list-item>
                                    <!-- <v-list-item><strong></strong></v-list-item> -->
                                    <v-list-item
                                        v-if="containsDocumentToValidate(item)"
                                        @click.stop="
                                            addRemoveReconciliationExpend(
                                                containsDocumentToValidate(item),
                                            )
                                        "
                                    >
                                        <v-list-item-title>Valider le document</v-list-item-title>

                                        <template #append>
                                            <v-icon size="x-small">$fa-thumbs-up</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        v-else-if="accountingItem.doc"
                                        @click.stop="addRemoveReconciliationExpend(accountingItem)"
                                    >
                                        <v-list-item-title>Afficher le document</v-list-item-title>

                                        <template #append>
                                            <v-icon size="x-small">$fa-eye</v-icon>
                                        </template>
                                    </v-list-item>
                                    <template v-if="alIndex === 0">
                                        <v-list-item
                                            v-if="
                                                !containsDocumentToValidate(item) &&
                                                showValidateReconciliation(item)
                                            "
                                            @click.stop="validateReconciliation(item)"
                                            :loading="actionLoading"
                                        >
                                            <v-list-item-title
                                                >Valider le lettrage{{
                                                    getReconciliationValidationType(item) ===
                                                    "PENDING_VALIDATION_FROM_CLIENT"
                                                        ? " client"
                                                        : ""
                                                }}
                                                auto</v-list-item-title
                                            >

                                            <template #append>
                                                <v-icon size="x-small">$fa-thumbs-up</v-icon>
                                            </template>
                                        </v-list-item>
                                        <v-list-item
                                            v-if="
                                                !containsDocumentToValidate(item) &&
                                                showValidateReconciliation(item)
                                            "
                                            @click.stop="deleteReconciliation(item)"
                                            :loading="actionLoading"
                                        >
                                            <v-list-item-title
                                                >Refuser le lettrage{{
                                                    getReconciliationValidationType(item) ===
                                                    "PENDING_VALIDATION_FROM_CLIENT"
                                                        ? "client "
                                                        : ""
                                                }}
                                                auto</v-list-item-title
                                            >

                                            <template #append>
                                                <v-icon size="x-small">$fa-thumbs-down</v-icon>
                                            </template>
                                        </v-list-item>
                                        <v-list-item
                                            v-else-if="showRemoveCashbox(item)"
                                            @click.stop="removeCashbox(item)"
                                            :loading="actionLoading"
                                        >
                                            <v-list-item-title
                                                >Retirer de la caisse</v-list-item-title
                                            >
                                            <template #append>
                                                <v-icon size="x-small">$fa-trash-alt</v-icon>
                                            </template>
                                        </v-list-item>
                                        <v-list-item
                                            v-else-if="showRemoveRemittance(item)"
                                            @click.stop="deleteReconciliation(item)"
                                            :loading="actionLoading"
                                        >
                                            <v-list-item-title
                                                >Retirer du paiement par chèque</v-list-item-title
                                            >

                                            <template #append>
                                                <v-icon size="x-small">$fa-trash-alt</v-icon>
                                            </template>
                                        </v-list-item>
                                        <v-list-item
                                            v-else-if="showRemoveCurrentAccount(item)"
                                            @click.stop="removeCurrentAccount(item)"
                                        >
                                            <v-list-item-title>{{
                                                removeCurrentAccountTitle
                                            }}</v-list-item-title>

                                            <template #append>
                                                <v-icon size="x-small">$fa-trash-alt</v-icon>
                                            </template>
                                        </v-list-item>
                                        <v-list-item
                                            v-else-if="showDeleteReconciliation(item)"
                                            @click.stop="deleteReconciliation(item)"
                                        >
                                            <v-list-item-title
                                                >Supprimer le lettrage</v-list-item-title
                                            >

                                            <template #append>
                                                <v-icon size="x-small">$fa-trash-alt</v-icon>
                                            </template>
                                        </v-list-item>
                                        <v-list-item
                                            v-else-if="
                                                showGroupNotReconciliatedAndWithImputation(item) &&
                                                enableRemoveImputation(item)
                                            "
                                            @click.stop="removeImputation(item)"
                                        >
                                            <v-list-item-title>{{
                                                removeImputationTitle(item)
                                            }}</v-list-item-title>

                                            <template #append>
                                                <v-icon size="x-small">$fa-trash-alt</v-icon>
                                            </template>
                                        </v-list-item>
                                        <v-list-item
                                            v-if="enableShowGeneralLedger(item)"
                                            @click.stop="showGeneralLedger(item)"
                                        >
                                            <v-list-item-title>Grand Livre</v-list-item-title>

                                            <template #append>
                                                <v-icon size="x-small">$fa-chevron-right</v-icon>
                                            </template>
                                        </v-list-item>
                                    </template>
                                </v-list>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr>
                            <td
                                :colspan="isAccountingUser ? 7 : 5"
                                :style="getCellStyle(0, false)"
                            />
                            <td
                                v-if="
                                    selectedCompany.solution !== 'MANAGEMENT' &&
                                    mode != 'GeneralLedger'
                                "
                                class="d-flex align-center justify-end"
                                :style="getCellStyle(0, false)"
                            >
                                <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                        <v-btn
                                            rounded="circle"
                                            elevation="0"
                                            class="mr-2"
                                            @click.stop="setOpenChat('INFORMATION_REQUEST')"
                                            v-if="!reconciliation || !reconciliation.id"
                                            size="x-small"
                                            v-bind="props"
                                            icon="$oss-chat"
                                        >
                                        </v-btn>
                                    </template>
                                    <span>Question</span>
                                </v-tooltip>
                                <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                        <v-btn-prev
                                            :disabled="previousDisabled()"
                                            @click.stop="previous()"
                                            v-bind="props"
                                        />
                                    </template>
                                    <span>Précédent</span>
                                </v-tooltip>

                                <v-btn-icon
                                    icon="$stop"
                                    size="small"
                                    elevation="0"
                                    color="secondary"
                                    @click.stop="back()"
                                    v-if="toBeDoneStatus"
                                />
                                <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                        <v-btn-next
                                            :disabled="nextDisabled()"
                                            @click.stop="next()"
                                            v-if="mode != 'GeneralLedger'"
                                            v-bind="props"
                                        />
                                    </template>
                                    <span>Suivant</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <div class="d-flex pt-3">
            <ReconciliationWizard
                v-show="!documentPanel && !bankTransactionPanel"
                v-if="editable"
                :reconciliationVue="reconciliationVue"
                @new-document="onNewDocument"
            >
            </ReconciliationWizard>
        </div>

        <!-- <v-card :class="!$vuetify.display.mobile ? 'default_card large':'elevation-0'" :style="!$vuetify.display.mobile ? 'padding-bottom: 20px; margin-bottom: 60px':'margin:0; background-color: transparent !important'" v-show="!documentPanel && !bankTransactionPanel">
                <v-card-text :class="!$vuetify.display.mobile ? '':'pa-0'">
                    <v-row v-for="(group, index) of groupedAccountingLines" :key="index" no-gutters class="mt-4">
                        <v-col :cols="$vuetify.display.mobile ? 12:9" class="d-flex align-center">
                            <v-data-table
                                :headers="groupItemsHeaders"
                                :items="group.items"
                                v-model:expanded="reconciliationExpanded"
                                :hide-default-header="index>0"
                                hide-default-footer
                                :items-per-page="-1"
                                class="table"
                                fixed-header
                                max-height="60vh"
                                :loading="loading"
                                style="width:100%"
                                xs12
                                v-if="!$vuetify.display.mobile">
                                <template v-slot:item="props">
                                    <tr style="cursor: pointer" :key="props.item.accountingLine ? props.item.accountingLine.id : props.item.id">
                                        <td class="text-center" @click="addRemoveReconciliationExpend(props.item)">
                                            <v-icon
                                                :small="true"
                                                class="mr-2"
                                            >{{ props.item.iconType }}</v-icon>
                                        </td>
                                        <td class="text-left" @click="addRemoveReconciliationExpend(props.item)">
                                            <div><v-chip outlined label size="small" color="grey" class="mr-2" v-if="(props.item.bt && props.item.bt.accountingItemImport)||(props.item.doc && props.item.doc.accountingItemImport)">Importé</v-chip>{{ props.item.name }}</div>
                                        </td>
                                        <td class="text-center" @click="addRemoveReconciliationExpend(props.item)">{{ props.item.date }}</td>
                                        <td class="text-right" @click="addRemoveReconciliationExpend(props.item)">{{ props.item.debit ? newCommonFormatCurrency(props.item.debit, undefined) : "-" }}</td>
                                        <td class="text-right" @click="addRemoveReconciliationExpend(props.item)">{{ props.item.credit ? newCommonFormatCurrency(props.item.credit, undefined) : "-"  }}</td>
                                    </tr>
                                </template>
                                <template v-slot:expanded-item="{ headers, item }" >
                                    <template v-if="item.doc">
                                        <tr v-if="item.signedUrl">
                                            <td :colspan="headers.length">
                                                <v-row align="center" justify="center" >
                                                    <v-img
                                                        :src="item.signedUrl"
                                                        lazy-src="../assets/logo.png"
                                                        width="60vw"
                                                        :contain="true"
                                                        class="elevation-5 ma-4"
                                                    ></v-img>
                                                </v-row>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                                <template v-slot:body.append v-if="index +1 === groupedAccountingLines.length">
                                    <tr>
                                        <td :colspan="3" class="text-right"> <strong>Totaux</strong></td>
                                        <td class="text-right">
                                            <strong>{{newCommonFormatCurrency(totalDebit, undefined)}}</strong>
                                        </td>
                                        <td class="text-right">
                                            <strong>{{newCommonFormatCurrency(totalCredit, undefined)}}</strong>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                            <v-card
                                elevation="0"
                                class="pa-2 mb-2"
                                style="border-radius: 8px; width:100%"
                                v-for="(item, index) in group.items"
                                :key="index"
                                v-else
                            >
                                <v-row no-gutters style="flex-wrap: nowrap;">
                                    <v-col
                                        style="min-width: 100px; max-width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
                                        class="flex-grow-1 flex-shrink-0"
                                    >
                                        <v-icon
                                             size="small"
                                            class="mr-2"
                                            >{{ item.iconType }}</v-icon>
                                        {{ item.name }}
                                    </v-col>
                                    <v-col
                                        style="min-width: 100px; max-width: 100%;"
                                        class="flex-grow-0 flex-shrink-1 d-flex justify-end"
                                    >
                                        <span :class="item.debit ? 'font-weight-bold primary--text' : 'error--text font-weight-bold'">
                                            {{ newCommonFormatCurrency(item.debit-item.credit, undefined) }}
                                        </span>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters style="flex-wrap: nowrap;">
                                    <v-col
                                        style="min-width: 100px; max-width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
                                        class="flex-grow-0 flex-shrink-1"
                                    >
                                        <v-icon  size="small" color="secondary" left>$oss-calendar</v-icon>
                                        {{ formatDateMobile(item.date) }}
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="3" class="d-flex align-center justify-center" v-if="!$vuetify.display.mobile">
                            <v-card>
                                <v-toolbar dense class="elevation-0" color="primary" >
                                    <v-toolbar-title>Statut : {{groupReconciliationStatus(group)}}</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <v-card-text>
                                    {{groupAllocation(group)}}
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mt-4" v-if="!$vuetify.display.mobile">
                        <v-col cols="9" class="d-flex align-center">
                        </v-col>
                        <v-col cols="3" class="d-flex align-center justify-center">
                                <v-btn
                                class="btn"
                                rounded="circle"
                                 size=“x-small”
                                elevation="0"
                                color="primary"
                                :disabled="previousDisabled()"
                                @click="previous()"
                                v-if="mode!='GeneralLedger'"
                            >
                                <v-icon>$navigate_before</v-icon>
                            </v-btn>
                            <v-btn
                                class="btn"
                                rounded="circle"
                                 size=“x-small”
                                elevation="0"
                                color="primary"
                                @click="back()"
                                v-if="toBeDoneStatus"
                            >
                            <v-icon>$stop</v-icon>
                            </v-btn>
                            <v-btn
                                :disabled="nextDisabled()"
                                class="btn"
                                rounded="circle"
                                 size=“x-small”
                                elevation="0"
                                color="primary"
                                @click="next()"
                                v-if="mode!='GeneralLedger'"
                            >
                                <v-icon>$navigate_next</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <ReconciliationWizard
                    v-show="!documentPanel && !bankTransactionPanel"
                    v-if="editable"
                    :reconciliationVue="reconciliationVue"
                    @new-document="onNewDocument"
                    >
                </ReconciliationWizard>
            </v-card> -->

        <v-card v-show="documentPanel" class="default_card_management">
            <!-- <v-card-title class="title font-weight-regular justify-space-between">
                <span>Choisissez un justificatif</span>
                <v-avatar
                    color="primary lighten-2"
                    class="subheading white--text"
                    size="24"
                    v-text="2"
                ></v-avatar>
            </v-card-title> -->
            <v-toolbar
                color="primary"
                class="elevation-0"
                style="
                    border-top-left-radius: 20px !important;
                    border-top-right-radius: 20px !important;
                "
            >
                <v-toolbar-title>Choisissez un justificatif</v-toolbar-title>
                <v-spacer />

                <v-btn-icon icon="$close" @click="documentPanel = false" style="margin: 0" />
            </v-toolbar>
            <v-card-text>
                <v-container fluid>
                    <v-layout xs12 align-center class="filter-layout" id="documents-filter-box">
                        <v-flex xs2 ml-2>
                            <oss-text-field
                                outlined
                                v-model="docFilter.amount.minimum"
                                label="Min"
                            />
                        </v-flex>
                        <v-flex xs2 ml-2>
                            <oss-text-field
                                outlined
                                v-model="docFilter.amount.maximum"
                                label="Max"
                            />
                        </v-flex>
                        <v-flex xs4 ml-2>
                            <oss-date-range-picker
                                :begin="docFilter.date.begin"
                                :end="docFilter.date.end"
                                @change-dateRange="onDocDateRangeChanged"
                            >
                            </oss-date-range-picker>
                        </v-flex>
                        <v-flex xs4 ml-2>
                            <v-text-field-filled
                                outlined
                                v-model="docFilter.search"
                                append-inner-icon="$search"
                                label="Recherche"
                            />
                        </v-flex>
                        <v-flex xs1 ml-2>
                            <v-btn
                                fab
                                size="x-small"
                                elevation-0
                                color="primary"
                                class="btn"
                                :disabled="isFiltered(defaultDocFilter, docFilter)"
                                @click="clearDocFilters()"
                                icon="$clear"
                            >
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-container fluid>
                    <v-data-table-server
                        :headers="selectionHeaders"
                        :items="accountingLines"
                        v-model:expanded="documentExpanded"
                        v-model:page="docFilter.pagination.page"
                        v-model:sort-by="docFilter.pagination.sortBy"
                        v-model:sort-desc="docFilter.pagination.descending"
                        v-model:items-per-page="docFilter.pagination.rowsPerPage"
                        :items-length="docFilter.pagination.totalItems"
                        :items-per-page-options="[5, 10, 25]"
                        class="table"
                        fixed-header
                        max-height="60vh"
                    >
                        <template v-slot:item="props">
                            <tr>
                                <td
                                    class="text-center"
                                    @click="addRemoveDocumentExpand(props.item)"
                                >
                                    {{ props.item.name }}
                                </td>
                                <td
                                    class="text-center"
                                    @click="addRemoveDocumentExpand(props.item)"
                                >
                                    {{ props.item.date }}
                                </td>
                                <td
                                    class="text-center"
                                    @click="addRemoveDocumentExpand(props.item)"
                                    :style="props.item.amountSigned < 0 ? 'color:red;' : ''"
                                >
                                    {{
                                        newCommonFormatCurrency(props.item.amountSigned, undefined)
                                    }}
                                </td>
                                <td
                                    @click="
                                        props.item.selected = !props.item.selected;
                                        onSelectItemChanged(props.item);
                                        documentPanel = false;
                                    "
                                >
                                    <v-btn rounded size="x-small">{{
                                        props.item.selected ? "Retirer" : "Ajouter"
                                    }}</v-btn>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:expanded-row="{ columns, item }">
                            <td :colspan="columns.length">
                                <v-row align="center" justify="center" v-if="item.signedUrl">
                                    <v-img
                                        :src="item.signedUrl"
                                        lazy-src="../assets/logo.png"
                                        width="60vw"
                                        :contain="true"
                                        class="elevation-5 ma-4"
                                    />
                                </v-row>
                            </td>
                        </template>
                    </v-data-table-server>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn rounded @click="documentPanel = false" size="small"> Précédent </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-show="bankTransactionPanel" class="default_card_management">
            <!-- <v-card-title class="title font-weight-regular justify-space-between">
                <span>Choisissez un mouvement bancaire</span>
                <v-avatar
                    color="primary lighten-2"
                    class="subheading white--text"
                    size="24"
                    v-text="2"
                ></v-avatar>
            </v-card-title> -->
            <v-toolbar
                color="ternary"
                class="elevation-0"
                style="
                    border-top-left-radius: 20px !important;
                    border-top-right-radius: 20px !important;
                "
            >
                <v-toolbar-title>Choisissez un mouvement bancaire</v-toolbar-title>
                <v-spacer />

                <v-btn-icon icon="$close" @click="bankTransactionPanel = false" style="margin: 0" />
            </v-toolbar>
            <v-card-text row xs12 wrap>
                <v-container fluid>
                    <v-layout align-center class="filter-layout" id="documents-btFilter-box">
                        <v-flex xs2 ml-2>
                            <oss-text-field
                                outlined
                                v-model="btFilter.amount.minimum"
                                label="Min"
                            />
                        </v-flex>
                        <v-flex xs2 ml-2>
                            <oss-text-field
                                outlined
                                v-model="btFilter.amount.maximum"
                                label="Max"
                            />
                        </v-flex>
                        <v-flex xs4 ml-2>
                            <oss-date-range-picker
                                :begin="btFilter.date.begin"
                                :end="btFilter.date.end"
                                @change-dateRange="onBTDateRangeChanged"
                            >
                            </oss-date-range-picker>
                        </v-flex>
                        <v-flex xs3 ml-2>
                            <v-text-field-filled
                                outlined
                                v-model="btFilter.search"
                                append-inner-icon="$search"
                                label="Recherche"
                            />
                        </v-flex>
                        <v-flex ml-2>
                            <v-btn
                                fab
                                size="x-small"
                                color="primary"
                                :disabled="isFiltered(defaultBTFilter, btFilter)"
                                @click="clearBTFilters()"
                                icon="$clear"
                            >
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container fuild>
                    <v-data-table-server
                        :headers="selectionHeaders"
                        :items="availableBankTransactions"
                        v-model:page="btFilter.pagination.page"
                        v-model:sort-by="btFilter.pagination.sortBy"
                        v-model:sort-desc="btFilter.pagination.descending"
                        v-model:items-per-page="btFilter.pagination.rowsPerPage"
                        :items-length="btFilter.pagination.totalItems"
                        :items-per-page-options="[5, 10, 25]"
                        class="table"
                        fixed-header
                        max-height="60vh"
                    >
                        <template v-slot:no-data>
                            <v-alert color="error" icon="warning" :model-value="true"
                                >no item</v-alert
                            >
                        </template>
                        <template v-slot:item="props">
                            <tr>
                                <td class="text-center">{{ props.item.name }}</td>
                                <td class="text-center">{{ props.item.date }}</td>
                                <td
                                    class="text-center"
                                    :style="props.item.amountSigned < 0 ? 'color:red;' : ''"
                                >
                                    {{
                                        newCommonFormatCurrency(props.item.amountSigned, undefined)
                                    }}
                                </td>
                                <td
                                    @click="
                                        props.item.selected = !props.item.selected;
                                        onSelectItemChanged(props.item);
                                        bankTransactionPanel = false;
                                    "
                                >
                                    <v-btn rounded size="x-small">{{
                                        props.item.selected ? "Retirer" : "Ajouter"
                                    }}</v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table-server>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn rounded @click="bankTransactionPanel = false" size="small">
                    Précédent
                </v-btn>
            </v-card-actions>
        </v-card>
        <!-- </v-container> -->
        <!-- Toolbar bottom -->
        <!-- <div class="text-center" v-if="!$vuetify.display.mobile">
            <div class="bottom-sheet">
                <div class="remote">
                    <v-container class="controller" elevation-1 style="pointer-events: auto;">
                        <v-btn
                            class="btn"
                            rounded="circle"
                             size=“x-small”
                            color="primary"
                            elevation="0"
                            :disabled="previousDisabled()"
                            @click="previous()"
                        >
                            <v-icon>$navigate_before</v-icon>
                        </v-btn>
                        <v-btn
                            class="btn"
                            rounded="circle"
                             size=“x-small”
                            color="primary"
                            elevation="0"
                            @click="back()"
                            v-if="toBeDoneStatus"
                        >
                            <v-icon>$stop</v-icon>
                        </v-btn>
                        <v-btn
                            :disabled="nextDisabled()"
                            class="btn"
                            rounded="circle"
                             size=“x-small”
                            color="primary"
                            elevation="0"
                            @click="next()"
                        >
                            <v-icon>$navigate_next</v-icon>
                        </v-btn>
                    </v-container>
                </div>
            </div>
        </div> -->

        <Chat
            v-if="openChat"
            :id="chatId"
            :inShowMessage="open_chat"
            :chatTitle="'Ligne bancaire'"
            :chatSubtitle="getChatSubTitle()"
            :showSmartChat="wishStatus !== 'DENIED'"
            @messageSent="onMessageSent($event)"
            @showMessageChanged="onShowMessageChanged($event)"
        />
    </v-container>
</template>

<script lang="ts">
import { ReconciliationFullBase } from "./ReconciliationFullBase";
import Chat from "./chat/Chat.vue";
import ReconciliationWizard from "./reconciliation/ReconciliationWizard.vue";
import { Component, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        ReconciliationWizard,
        Chat,
    },
    emits: ["back"],
})
export class ReconciliationFullClient extends ReconciliationFullBase {
    @Prop({ default: false }) openPoints: boolean;
    @Prop({ default: true }) editable: boolean;

    selectionHeaders = [
        { title: "Nom", value: "name", sortable: true },
        { title: "Date", value: "date", sortable: true },
        { title: "Montant", value: "amountSigned", sortable: false },
        { title: "", value: "", sortable: false },
    ];

    localBack() {
        if (!this.openPoints) {
            this.back();
        }
        return this.$emit("back");
    }

    get clientTitle() {
        if (this.waitingBTItem && this.editable) {
            let title = "Justifier ce règlement";
            if (this.waitingBTItem.accountingLine.thirdPartyCompany) {
                if (this.waitingBTItem.accountingLine.accountableAccount) {
                    if (
                        this.waitingBTItem.accountingLine.accountableAccount.name.startsWith("401")
                    ) {
                        title += " du fournisseur ";
                    } else if (
                        this.waitingBTItem.accountingLine.accountableAccount.name.startsWith("401")
                    ) {
                        title += " du client ";
                    } else {
                        title += " de ";
                    }
                }
                title += this.waitingBTItem.accountingLine.thirdPartyCompany.name;
            }
            return title;
        }
        return this.title;
    }

    // onNewDocument() {
    //     this.localBack()
    // }
}

export default toNative(ReconciliationFullClient);
</script>
